module.exports = __webpack_public_path__ + "img/foul.c8236a50.gif";